import { createSlice } from "@reduxjs/toolkit";
import { getDateWhenString } from "common/date-utils";
export const initialState = {
    notificationPanel: {
        isOpen: false,
        synInProgress: false
    }
};
const slice = createSlice({
    initialState,
    name: "notificationsReducers",
    reducers: {
        toggleNotificationsPanel(state, action) {
            state.notificationPanel.isOpen = action.payload;
        },
        updateNotificationsLastSyncDate: (state, action) => {
            if (state.notificationPanel.lastSynchronisationDate === undefined) {
                state.notificationPanel.lastSynchronisationDate = action.payload?.lastSynchronisationDate;
                state.notificationPanel.synInProgress = action.payload?.synInProgress;
            }
            else if (action.payload?.lastSynchronisationDate !== undefined) {
                const lastopdate = getDateWhenString(state.notificationPanel.lastSynchronisationDate);
                const newdate = getDateWhenString(action.payload.lastSynchronisationDate);
                if (lastopdate < newdate) {
                    state.notificationPanel.lastSynchronisationDate = action.payload?.lastSynchronisationDate;
                    state.notificationPanel.synInProgress = action.payload?.synInProgress;
                }
            }
        }
    }
});
export const notificationsReducers = slice.reducer;
export const { updateNotificationsLastSyncDate, toggleNotificationsPanel } = slice.actions;
